import axios from "axios";

const API = axios.create({
  // baseURL: "https://anton.markcoders.com/linton_backend/api",
  baseURL: "https://xdtc.lintonusa.com/server/api",
});
API.interceptors.request.use(
  (request) => {
    const auth = "Bearer " + localStorage.getItem("token");
    request.headers["Accept"] = "application/json";
    request.headers["Authorization"] = auth;
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default API;

//https://aws.markcoders.com/server/api  //Staging
//https://xdtc.lintonusa.com/server/api  //Production
//http://localhost:6000/api              //Local
//http://192.168.18.83:6001/api          //Local
